import React, {useEffect, useMemo, useRef, useState} from "react";
import {Empty, Spin} from "antd";
import iframeResize from "iframe-resizer/js/iframeResizer";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {MetabaseDashboardContainer, MetabaseIframe} from "./metabaseReports.styles";

/**
 * Backend'de kullanıcının bölge yetkisine göre imzalanan token ile Metabase
 * dashboard'unu gömer. Yeni bir dashboard eklemek için sadece dashboardKey verilir.
 */
const MetabaseDashboard = ({dashboardKey}) => {
    const stores = useStore();
    const [iframeLoading, setIframeLoading] = useState(true);
    const iframeRef = useRef(null);

    const [tokenLoading, response] = useFetch({
        fetchFn: stores.metabaseReportStore.getEmbedToken.bind(null, {dashboardKey}),
        dependencies: [dashboardKey],
        defaultDataValue: null
    });

    const embedUrl = useMemo(() => {
        const {token, instanceUrl} = response || {};
        if (!token || !instanceUrl) return "";

        return `${instanceUrl}/embed/dashboard/${token}#titled=true&downloads=true&bordered=false&background=false`;
    }, [response]);

    // Metabase gömülü sayfaları iframe-resizer'ın contentWindow scriptini yüklüyor.
    // Parent tarafını da bağlayınca iframe içerik yüksekliğine göre uzuyor ve
    // iç scroll yerine sayfanın kendi scroll'u kullanılıyor.
    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe || !embedUrl) return undefined;

        let instanceOrigin;
        try {
            instanceOrigin = new URL(embedUrl).origin;
        } catch (e) {
            instanceOrigin = null;
        }

        iframeResize(
            {
                log: false,
                checkOrigin: instanceOrigin ? [instanceOrigin] : false,
                heightCalculationMethod: "max"
            },
            iframe
        );

        return () => {
            iframe?.iFrameResizer?.removeListeners();
        };
    }, [embedUrl]);

    if (!tokenLoading && !embedUrl) {
        return <Empty description="Rapor yüklenemedi." />;
    }

    return (
        <MetabaseDashboardContainer>
            <Spin spinning={tokenLoading || iframeLoading} size="large">
                {embedUrl && (
                    <MetabaseIframe
                        ref={iframeRef}
                        src={embedUrl}
                        title="Metabase Dashboard"
                        allowtransparency="true"
                        onLoad={() => setIframeLoading(false)}
                    />
                )}
            </Spin>
        </MetabaseDashboardContainer>
    );
};

export default MetabaseDashboard;
